import React, { useState } from "react";
import InterviewSetupHeader from "./InterviewSetupHeader";
import InterviewCameraPreview from "./InterviewCameraPreview";
import InterviewDetails from "./InterviewDetails";
import InterviewInterface from "./InterviewInterface";
import { useDispatch, useSelector } from "react-redux";
import { setInterviewModal } from "../../../store/studentPageReducer";

const InterviewSetup = () => {
  const dispatch = useDispatch();
  const { activeInterview } = useSelector((state) => state.studentpage);
  const { user } = useSelector((state) => state.login.student);
  const [isValidationPassed, setIsValidationPassed] = useState(false);
  const [showInterviewInterface, setShowInterviewInterface] = useState(false);

  const onClose = () => {
    dispatch(setInterviewModal(false));
  };

  const handleStartInterview = () => {
    setShowInterviewInterface(true);
  };

  const handleEndInterview = () => {
    setShowInterviewInterface(false);
    dispatch(setInterviewModal(false));
  };


  const loggedInEmail = user?.email || "";
  const interviewId = activeInterview?.id || activeInterview?.interview_id || activeInterview?.schedule_id;
  const studentEmail = activeInterview?.student_email || loggedInEmail;
  const candidateName = activeInterview?.student_name || studentEmail.split("@")[0] || "Student";
  const studentId = activeInterview?.student_id || studentEmail;

  if (showInterviewInterface) {
    return (
      <InterviewInterface
        interviewId={interviewId}
        candidateName={candidateName}
        studentId={studentId}
        interviewName={activeInterview?.interview_name || activeInterview?.interview_type || "Interview"}
        duration={activeInterview?.duration || 30}
        onEndInterview={handleEndInterview}
      />
    );
  }

  return (
    <div className="bg-white rounded-lg max-w-5xl w-full p-8">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black p-4 overflow-auto">
        <div className="relative w-full h-full max-h-screen overflow-auto bg-white rounded-lg p-8 max-w-5xl">
          <InterviewSetupHeader activeInterview={activeInterview} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <InterviewCameraPreview onValidationChange={setIsValidationPassed} />
            <InterviewDetails />
          </div>
          <div className="flex space-x-3">
            <button
              className="flex-1 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-medium transition-colors"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={`flex-1 px-6 py-3 rounded-lg font-medium transition-colors ${
                isValidationPassed
                  ? "bg-yellow-400 text-white hover:bg-yellow-500 cursor-pointer"
                  : "bg-yellow-400 text-white opacity-50 cursor-not-allowed"
              }`}
              type="button"
              disabled={!isValidationPassed}
              onClick={handleStartInterview}
            >
              Start Interview
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewSetup;
